import React from 'react';

interface CenterLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export default function CenterLayout({ children, className = "" }: CenterLayoutProps) {
  return (
    <div className={`container mx-auto px-4 py-8 pt-40 max-w-6xl ${className}`}>
      {children}
    </div>
  );
}